import { Facebook, Instagram, Mail } from "lucide-react";

// TikTok icon (Lucide doesn't include it)
export const TikTok = ({ size = 18, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export const SOCIAL_LINKS = {
  facebook: "https://facebook.com/offlineandavailable",
  instagram: "https://instagram.com/offlineandavailable",
  tiktok: "https://tiktok.com/@offlineandavailable",
  email: "mailto:hello@offlineandavailable.com",
};

export function SocialIcons({ size = 18, gap = "gap-4", className = "text-neutral-700" }) {
  return (
    <div className={`flex items-center ${gap} ${className}`} data-testid="social-icons">
      <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-black transition-colors" data-testid="social-instagram"><Instagram size={size} strokeWidth={1.5} /></a>
      <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-black transition-colors" data-testid="social-facebook"><Facebook size={size} strokeWidth={1.5} /></a>
      <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" className="hover:text-black transition-colors" data-testid="social-tiktok"><TikTok size={size} /></a>
      <a href={SOCIAL_LINKS.email} aria-label="Email" className="hover:text-black transition-colors" data-testid="social-email"><Mail size={size} strokeWidth={1.5} /></a>
    </div>
  );
}
